// src/utils/ean13Pdf.js
//
// Рисует штрихкод EAN-13 прямо в jsPDF чёрными прямоугольниками (вектор).
// Векторные полоски сканируются надёжнее растровой картинки и не мылятся
// при печати. Никаких внешних библиотек.
//
// EAN-13: 95 модулей = 3 (guard) + 6×7 (левая) + 5 (middle) + 6×7 (правая) + 3 (guard).
// Первая цифра кодируется чередованием наборов L/G в левой половине.

// Наборы кодов (7 бит на цифру)
const L = ['0001101','0011001','0010011','0111101','0100011','0110001','0101111','0111011','0110111','0001011'];
const G = ['0100111','0110011','0011011','0100001','0011101','0111001','0000101','0010001','0001001','0010111'];
const R = ['1110010','1100110','1101100','1000010','1011100','1001110','1010000','1000100','1001000','1110100'];
// Какой набор (L или G) для 6 цифр левой половины, по первой цифре
const PARITY = ['LLLLLL','LLGLGG','LLGGLG','LLGGGL','LGLLGG','LGGLLG','LGGGLL','LGLGLG','LGLGGL','LGGLGL'];

function ean13Pattern(code) {
  const d = code.split('').map(n => n.charCodeAt(0) - 48);
  const parity = PARITY[d[0]];
  let bits = '101'; // левый guard
  for (let i = 0; i < 6; i++) {
    const digit = d[1 + i];
    bits += (parity[i] === 'L' ? L : G)[digit];
  }
  bits += '01010'; // middle guard
  for (let i = 0; i < 6; i++) {
    bits += R[d[7 + i]];
  }
  bits += '101'; // правый guard
  return bits; // 95 символов
}

/**
 * Нарисовать EAN-13 в документе jsPDF.
 * doc — экземпляр jsPDF (единицы mm)
 * code — 13 цифр
 * x, y — левый верхний угол области штрихкода (mm)
 * width, height — размеры области полосок (mm)
 * withText — печатать ли цифры под кодом
 */
export function drawEan13(doc, code, x, y, width, height, withText = true) {
  const c = String(code || '').replace(/\D/g, '');
  if (c.length !== 13) return;

  const bits = ean13Pattern(c);
  const moduleW = width / 95;

  doc.setFillColor(0, 0, 0);
  for (let i = 0; i < bits.length; i++) {
    if (bits[i] === '1') {
      doc.rect(x + i * moduleW, y, moduleW, height, 'F');
    }
  }

  if (withText) {
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(8);
    // цифры под штрихкодом, моноширинно по центру
    doc.text(c, x + width / 2, y + height + 3, { align: 'center' });
  }
}
